import React from 'react';
import './Card.css';

const Card = ({ student, selectedBackground, customBackground, cardRefs, handleSelectCard, selectedCards, downloadCard }) => {
  const qrCodeUrl = student.id
    ? `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(student.id)}`
    : null;

  // Format date of birth
  let displayDob = 'N/A';
  if (student.dateOfBirth) {
    try {
      let dobDate;
      if (student.dateOfBirth.includes('/')) {
        const [day, month, year] = student.dateOfBirth.split('/');
        dobDate = new Date(`${year}-${month}-${day}`);
      } else {
        dobDate = new Date(student.dateOfBirth);
      }
      if (!isNaN(dobDate.getTime())) {
        displayDob = dobDate.toLocaleDateString('vi-VN', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
      } else {
        displayDob = student.dateOfBirth;
      }
    } catch (error) {
      console.error(`Lỗi định dạng ngày sinh cho học sinh ${student.id}:`, error);
      displayDob = student.dateOfBirth;
    }
  }

  const backgroundClass =
    selectedBackground === 'custom' ? 'card-bg-custom' : `card-bg-${selectedBackground.replace('bg-', '')}`;
  const cardStyle =
    selectedBackground === 'custom' && customBackground
      ? { backgroundImage: `url(${customBackground})` }
      : {};

  return (
    <tr key={student.id}>
      <td>
        <input
          type="checkbox"
          checked={selectedCards.includes(student.id)}
          onChange={() => handleSelectCard(student.id)}
        />
      </td>
      <td>
        <div
          className={`card ${backgroundClass}`}
          style={cardStyle}
          ref={(el) => (cardRefs.current[student.id] = el)}
        >
          <div className="header">
            GIÁO XỨ AN NHƠN
            <br />
            TRƯỜNG GIÁO LÝ THIẾU NHI
          </div>
          <img src="/logo.png" alt="Logo" className="logo" crossOrigin="anonymous" />
          <div className="content content-card">
            <div>
              <b>THẺ THIẾU NHI</b>
            </div>
            <h2>{student.name}</h2>
            <p>
              Tên Thánh:<br />
              <b>{student.holyName || 'N/A'}</b>
            </p>
            <p>
              Họ và Tên:{" "}
              {student.fullName && student.fullName.length > 22 ? (
                <b>{student.fullName || 'N/A'}</b>
              ) : (
                <>
                  <br />
                  <b>{student.fullName || 'N/A'}</b>
                </>
              )}
            </p>
            <p>
              Ngày sinh:<br />
              <b>{displayDob}</b>
            </p>
          </div>
          <div className="qr-code">
            {qrCodeUrl ? (
              <img
                src={qrCodeUrl}
                alt="QR Code"
                className="qr-code-image"
                crossOrigin="anonymous"
              />
            ) : (
              <p className="text-xs text-red-500">Không có QR Code</p>
            )}
            <div className="id-text">
              ID: {student.id}
            </div>
          </div>
        </div>
      </td>
      <td>
        <button
          onClick={() => downloadCard(student.id)}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Tải về
        </button>
      </td>
    </tr>
  );
};

export default Card;